import {NgModule} from '@angular/core';
import {MaterialModule} from '../material/material.module';
import {AirlineEditComponent} from './components/airline-edit/airline-edit.component';
import {AirlinesComponent} from './components/airlines/airlines.component';
import {AirlineService} from './services/airline/airline.service';
import {FormsModule} from '@angular/forms';
import {UtilitiesModule} from '../utilities/utilities.module';
import {RouterModule} from '@angular/router';
import {CommonModule} from '@angular/common';
import {ContractModule} from '../contract/contract.module';
import {ReportModule} from '../report/report.module';

@NgModule({
  declarations: [
    AirlineEditComponent,
    AirlinesComponent
  ],
  imports: [
    MaterialModule,
    CommonModule,
    FormsModule,
    UtilitiesModule,
    RouterModule,
    ContractModule,
    ReportModule
  ],
  exports: [
  ],
  providers: [
    AirlineService,
  ]
})
export class AirlineModule { }



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/airline/airline.module.ts